import { Navigate } from "react-router";
import { detectLang } from "@/config/routes";

export function LanguageRedirect() {
	const lang = detectLang();
	return <Navigate to={`/${lang}/`} replace />;
}
